import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { govCertapplyActions } from '../../../../store/actions'
import { alertActions } from '../../../../store/actions'

import PrivacyPopup from './PrivacyPopup'
import history from '../../../../route/history'

const GovEDocApplyDrivers = (props) => {
  // 사용자 신청 데이터
  const [userInfo, setUserInfo] = useState({
    memberName: '', //신청인
    ecdwAdres: 'ecdwAdres',
    applyID: '3', // 운전면허경력증명서: "3", 사업자등록증명신청발급서: "22"
    docKndCode: '30000100011', // 문서종류코드
    docKndNm: '운전경력증명서', // 문서종류명

    // 4자리 숫자(전체 선택시 9900)
    driversLicense: '9900', // 운전면허경력
    trafficAccident: '9900', // 교통사고
    infringement: '9900', // 법규위반

    reasonIssue: '', // 발급사유
  })

  const [periodInfo, setPeriodInfo] = useState({
    period1ChkYn: 'Y',
    period2ChkYn: 'Y',
    period3ChkYn: 'Y',

    period1Year: '',
    period1Month: '',
    period2Year: '',
    period2Month: '',
    period3Year: '',
    period3Month: '',
  })

  const [state, setState] = useState({
    isAgree: false, // 약관 동의 체크
    isPopup: false, // 개인정보 동의 팝업 오픈 여부
  })

  useEffect(() => {
    // 초기 작업
  }, [])

  useEffect(() => {
    if (props.user?.memberName != undefined) {
      setUserInfo({
        ...userInfo,
        memberName: props.user?.memberName,
      })
    }
  }, [props.user?.memberName])

  useEffect(() => {
    if (props.ECDApplyQFVerifyResult != null) {
      if (props.ECDApplyQFVerifyResult.rspnsCode === '100' && props.ECDApplyResult === null) {
        props.ECDApply(userInfo)
      } else if (props.ECDApplyQFVerifyResult.rspnsCode !== '100') {
        return props.error({ message: props.ECDApplyQFVerifyResult.rspnsMssage })
      }
    }
  }, [props.ECDApplyQFVerifyResult])

  useEffect(() => {
    if (props.ECDApplyResult != null) {
      if (props.ECDApplyResult.rspnsCode === '100') {
        props.success({
          message: '신청이 완료 되었습니다.',
          params: {
            type: 'SUCCESS',
            callback: () => {
              history.goBack()
            },
          },
        })
      } else if (props.ECDApplyResult.rspnsCode !== '100') {
        return props.error({ message: props.ECDApplyResult.rspnsMssage })
      }
    }
  }, [props.ECDApplyResult])

  function submitHandler() {
    /*****************************************************************************************************************
     * 신청하기 전 경력 셋팅
     *****************************************************************************************************************/
    let driversLicense = '9900'
    let trafficAccident = '9900'
    let infringement = '9900'
    periodInfo.period1ChkYn === 'N' && (driversLicense = periodInfo.period1Year + periodInfo.period1Month)
    periodInfo.period2ChkYn === 'N' && (trafficAccident = periodInfo.period2Year + periodInfo.period2Month)
    periodInfo.period3ChkYn === 'N' && (infringement = periodInfo.period3Year + periodInfo.period3Month)
    /*****************************************************************************************************************
     * 필수값 체크
     *****************************************************************************************************************/
    // 이름 필수값 체크
    if (!userInfo.memberName?.trim()) {
      return props.error({ message: '이름을 입력 해주세요.' })
    }
    // 운전면허 경력 필수값 체크
    if (!driversLicense) {
      return props.error({ message: '운전면허 경력을 입력 해주세요.' })
    }
    // 교통사고 경력 필수값 체크
    if (!trafficAccident) {
      return props.error({ message: '교통사고 경력을 입력 해주세요.' })
    }
    // 법규위반 경력 필수값 체크
    if (!infringement) {
      return props.error({ message: '법규위반 경력을 입력 해주세요.' })
    }
    // 발급사유 필수값 체크
    if (!userInfo.reasonIssue?.trim()) {
      return props.error({ message: '발급사유를 작성해주세요.' })
    }
    // 약관 동의 필수값 체크
    if (!state.isAgree) {
      return props.error({ message: '개인정보 제공 동의에 체크하셔야 합니다.' })
    }
    /*****************************************************************************************************************
     * 유효성 검사
     *****************************************************************************************************************/
    // 운전면허 경력 유효성 체크
    if (isNaN(driversLicense) || !(driversLicense.length === 4)) {
      return props.error({ message: '운전면허 경력 기간은 (2자리 숫자 + 2자리 숫자) 형식으로 입력해주세요.' })
    } else if (periodInfo.period1ChkYn === 'N' && periodInfo.period1Month > 11) {
      return props.error({ message: '운전면허 경력 기간의 두번째 입력 값은 12(개월)보다 작은 숫자를 입력해주세요.' })
    }
    // 교통사고 경력 유효성 체크
    if (isNaN(trafficAccident) || !(trafficAccident.length === 4)) {
      return props.error({ message: '교통사고 경력 기간은 (2자리 숫자 + 2자리 숫자) 형식으로 입력해주세요.' })
    } else if (periodInfo.period2ChkYn === 'N' && periodInfo.period2Month > 11) {
      return props.error({ message: '운전면허 경력 기간의 두번째 입력 값은 12(개월)보다 작은 숫자를 입력해주세요.' })
    }
    // 법규위반 경력 유효성 체크
    if (isNaN(infringement) || !(infringement.length === 4)) {
      return props.error({ message: '법규위반 경력 기간은 (2자리 숫자 + 2자리 숫자) 형식으로 입력해주세요.' })
    } else if (periodInfo.period3ChkYn === 'N' && periodInfo.period3Month > 11) {
      return props.error({ message: '운전면허 경력 기간의 두번째 입력 값은 12(개월)보다 작은 숫자를 입력해주세요.' })
    }
    // 발급사유 유효성 체크
    if (userInfo.reasonIssue.length > 200) {
      return props.error({ message: '발급사유는 200자리 이하로 입력해주세요.' })
    }

    const params = {
      ...userInfo,
      infringement,
      trafficAccident,
      driversLicense,
    }
    setUserInfo(params)

    props.ECDApplyQFVerify(params)
  }

  const period1RadioHandler = (e) => {
    const { id } = e.target
    setPeriodInfo((prePeriodInfo) => ({
      ...prePeriodInfo,
      period1ChkYn: id === 'period1-1' ? 'Y' : 'N',
    }))
  }
  const period2RadioHandler = (e) => {
    const { id } = e.target
    setPeriodInfo((prePeriodInfo) => ({
      ...prePeriodInfo,
      period2ChkYn: id === 'period2-1' ? 'Y' : 'N',
    }))
  }
  const period3RadioHandler = (e) => {
    const { id } = e.target
    setPeriodInfo((prePeriodInfo) => ({
      ...prePeriodInfo,
      period3ChkYn: id === 'period3-1' ? 'Y' : 'N',
    }))
  }

  const periodHandler = (e) => {
    const { name, value } = e.target
    setPeriodInfo({
      ...periodInfo,
      [name]: value,
    })
  }

  const inputHandleChange = (e) => {
    const { name, value } = e.target
    setUserInfo({
      ...userInfo,
      [name]: value,
    })
  }

  /**
   * 개인정보 동의 체크박스
   */
  function checkHandler(e) {
    const value = e.target.checked
    setState({ ...state, isAgree: value })
  }

  return (
    <>
      <div id="contents">
        <div className="content-header">
          <a
            href="#"
            className="page-prev"
            onClick={(e) => {
              e.preventDefault()
              window.history.back()
            }}
          >
            뒤로이동
          </a>
          <h2>운전자경력증명</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>증명서 신청</span>
            <span>증명서 신청</span>
            <em>운전자경력증명</em>
          </div>
        </div>
        <div className="certificate-mobile">
          <h3 className="h3-tit first">신청인</h3>
          <p className="required">* 표시는 필수 입력사항입니다.</p>
          <table className="tbl-write">
            <colgroup>
              <col className="col1" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <em className="required" /> 성명
                </th>
                <td>
                  <input
                    name="memberName"
                    type="text"
                    defaultValue={userInfo.memberName}
                    className="form-keyword"
                    onChange={inputHandleChange}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <h3 className="h3-tit">희망 기간</h3>
          <p className="required">* 표시는 필수 입력사항입니다.</p>
          <p className="required">
            * 희망기간은 운전면허소지 기간과 관계없이 신청일부터
            <br /> 계산되는 기간입니다
          </p>
          <table className="tbl-write">
            <colgroup>
              <col className="col1" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <em className="required" /> 운전면허경력
                </th>
                <td>
                  <div className="input-group">
                    <span className="radio-group">
                      <input
                        type="radio"
                        id="period1-1"
                        name="period1"
                        defaultChecked={periodInfo.period1ChkYn === 'Y'}
                        onChange={period1RadioHandler}
                      />
                      <em />
                      <label htmlFor="period1-1">전체경력</label>
                      <input
                        type="radio"
                        id="period1-2"
                        name="period1"
                        defaultChecked={periodInfo.period1ChkYn === 'N'}
                        onChange={period1RadioHandler}
                      />
                      <em />
                      <label htmlFor="period1-2">최근</label>
                    </span>
                    <input
                      type="text"
                      className="w50"
                      name="period1Year"
                      onChange={periodHandler}
                      readOnly={periodInfo.period1ChkYn === 'Y'}
                      placeholder="00"
                    />
                    <span>년</span>
                    <input
                      type="text"
                      className="w50"
                      name="period1Month"
                      onChange={periodHandler}
                      readOnly={periodInfo.period1ChkYn === 'Y'}
                      placeholder="00"
                    />
                    <span>개월</span>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 법규위반
                </th>
                <td>
                  <div className="input-group">
                    <span className="radio-group">
                      <input
                        type="radio"
                        id="period2-1"
                        name="period2"
                        defaultChecked={periodInfo.period2ChkYn === 'Y'}
                        onChange={period2RadioHandler}
                      />
                      <em />
                      <label htmlFor="period2-1">전체경력</label>
                      <input
                        type="radio"
                        id="period2-2"
                        name="period2"
                        defaultChecked={periodInfo.period2ChkYn === 'N'}
                        onChange={period2RadioHandler}
                      />
                      <em />
                      <label htmlFor="period1-2">최근</label>
                    </span>
                    <input
                      type="text"
                      className="w50"
                      name="period2Year"
                      onChange={periodHandler}
                      readOnly={periodInfo.period2ChkYn === 'Y'}
                      placeholder="00"
                    />
                    <span>년</span>
                    <input
                      type="text"
                      className="w50"
                      name="period2Month"
                      onChange={periodHandler}
                      readOnly={periodInfo.period2ChkYn === 'Y'}
                      placeholder="00"
                    />
                    <span>개월</span>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 법규위반
                </th>
                <td>
                  <div className="input-group">
                    <span className="radio-group">
                      <input
                        type="radio"
                        id="period3-1"
                        name="period3"
                        defaultChecked={periodInfo.period3ChkYn === 'Y'}
                        onChange={period3RadioHandler}
                      />
                      <em />
                      <label htmlFor="period3-1">전체경력</label>
                      <input
                        type="radio"
                        id="period3-2"
                        name="period3"
                        defaultChecked={periodInfo.period3ChkYn === 'N'}
                        onChange={period3RadioHandler}
                      />
                      <em />
                      <label htmlFor="period3-2">최근</label>
                    </span>
                    <input
                      type="text"
                      className="w50"
                      name="period3Year"
                      onChange={periodHandler}
                      readOnly={periodInfo.period3ChkYn === 'Y'}
                      placeholder="00"
                    />
                    <span>년</span>
                    <input
                      type="text"
                      className="w50"
                      name="period3Month"
                      onChange={periodHandler}
                      readOnly={periodInfo.period3ChkYn === 'Y'}
                      placeholder="00"
                    />
                    <span>개월</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <h4 className="h4-tit">신청내용</h4>
          <p className="required">* 표시는 필수 입력사항입니다.</p>
          <table className="tbl-write">
            <colgroup>
              <col className="col1" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <em className="required" /> 발급사유
                </th>
                <td>
                  <input
                    name="reasonIssue"
                    type="text"
                    className="form-keyword"
                    placeholder="예)면접용 제출"
                    onChange={inputHandleChange}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <h4 className="h4-tit">약관 동의</h4>
          <div className="check-box">
            <input type="checkbox" id="agree" onChange={(e) => checkHandler(e)} />
            <em />
            <label htmlFor="agree" onClick={() => setState({ ...state, isPopup: !state.isPopup })}>
              개인정보 제 3자 제공 동의
            </label>
          </div>
          <div className="btn-block center">
            <button href="#" className="btn-primary lg w200" onClick={submitHandler}>
              신청하기
            </button>
          </div>
        </div>
      </div>
      {state.isPopup && <PrivacyPopup onClose={() => setState({ ...state, isPopup: false })} />}
      {/* <Alert /> */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.userinfo.data,
    ECDApplyQFVerifyResult: state.govcertapply.ECDApplyQFVerifyResult,
    ECDApplyResult: state.govcertapply.ECDApplyResult,
    isLoading: state.govcertapply.isLoading,
    isFailure: state.govcertapply.isFailure,
  }
}

const actionCreators = {
  ECDApplyQFVerify: govCertapplyActions.ECDApplyQFVerify,
  ECDApply: govCertapplyActions.ECDApply,
  error: alertActions.error,
  success: alertActions.success,
}

export default connect(mapStateToProps, actionCreators)(GovEDocApplyDrivers)
